import {
  VisibilityOffOutlined as VisibilityOffOutlinedIcon,
  VisibilityOutlined as VisibilityOutlinedIcon,
} from '@mui/icons-material';
import { IconButton } from '@mui/material';
import type { MouseEventHandler } from 'react';

interface EyeIconButtonProps {
  isHighlighted?: boolean;
  showOffWhenDisabled?: boolean;
  keepInheritedColorWhenHighlighted?: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
}

export const EyeIconButton = (props: EyeIconButtonProps) => {
  return (
    <IconButton sx={{ padding: 0.6 }} onClick={props.onClick}>
      {props.showOffWhenDisabled && !props.isHighlighted ? (
        <VisibilityOffOutlinedIcon color="inherit" />
      ) : (
        <VisibilityOutlinedIcon
          color={
            props.isHighlighted && !props.keepInheritedColorWhenHighlighted
              ? 'primary'
              : 'inherit'
          }
        />
      )}
    </IconButton>
  );
};
